import styled from '@emotion/styled';
import Drawer from '@mui/material/Drawer';

import { materialTheme } from '../../particles/theme';

const GOLD = '#f0cf69';
const GOLD_HOVER_WASH = 'rgba(240, 207, 105, 0.10)';
const BLUE_HOVER_WASH = 'rgba(52, 130, 207, 0.18)';

const StyledSideNav = styled(Drawer)<{ $open: boolean; $mobile?: boolean }>`
  height: 100%;
  display: flex;
  white-space: nowrap;
  padding: 0.7rem;
  background: linear-gradient(180deg, #3182ce 0%, #887bdc 32%, #2b2258 100%);
  border-radius: 0;

  .MuiDrawer-paper {
    width: 100%;
    background: linear-gradient(180deg, #3182ce 0%, #887bdc 32%, #2b2258 100%);
    ${(props) => (props.$mobile ? '' : 'position: unset;')}
    overflow-x: hidden;
    ${(props) => (props.$mobile ? 'padding: 0.7rem;' : '')}
  }

  .MuiDrawer-paperAnchorDockedLeft {
    border-right: unset;
  }

  /* Row shell — reset MUI defaults so the sliding indicator owns the pill */
  .MuiListItem-root {
    position: relative;
    z-index: 1;
    border-radius: 8px;
    margin: 2px 0;
    transition:
      background-color 220ms ease,
      color 220ms ease;
  }

  .MuiListItem-root.Mui-selected,
  .MuiListItem-root.Mui-selected:hover {
    background-color: transparent;
  }

  .MuiListItemIcon-root {
    transition: transform 200ms ease, color 220ms ease;
  }

  .MuiListItemText-root {
    color: rgba(255, 255, 255, 0.85);
    letter-spacing: 0.02rem;
    font-family: ${materialTheme.typography.fontFamily};
  }

  .MuiListItemIcon-root,
  .MuiSvgIcon-root {
    color: rgba(255, 255, 255, 0.75);
  }

  /* Hover: icon scales + soft blue→gold wash fills row from left */
  .primary .MuiListItem-button:hover {
    background: linear-gradient(90deg, ${BLUE_HOVER_WASH} 0%, ${GOLD_HOVER_WASH} 100%);
  }

  .primary .MuiListItem-button:hover .MuiListItemIcon-root {
    transform: scale(1.08);
    color: ${GOLD};
  }

  .primary .MuiListItem-button:hover .MuiListItemText-root {
    color: #ffffff;
  }

  /* Active row: gold text + gold icon (background pill is the sliding indicator) */
  .primary-selected .MuiListItemIcon-root,
  .primary-selected .MuiSvgIcon-root {
    color: ${GOLD};
  }

  .primary-selected .MuiListItemText-root {
    color: #ffffff;
    font-weight: 600;
  }

  .MuiTouchRipple-child {
    background-color: ${GOLD};
    border-radius: 0.5rem;
  }

  /* Open / close transition (desktop only — mobile uses a temporary Drawer whose
     paper width is set below and does not participate in the docked width toggle) */
  ${(props) => {
    if (props.$mobile) {
      return `
        width: auto;
        .MuiDrawer-paper { width: 260px; }
      `;
    }
    if (props.$open) {
      return `
        width: 230px;
        transition: ${materialTheme.transitions.create(`width`, {
          easing: materialTheme.transitions.easing.sharp,
          duration: materialTheme.transitions.duration.enteringScreen
        })};
      `;
    } else {
      return `
        width: 55px;
        transition: ${materialTheme.transitions.create(`width`, {
          easing: materialTheme.transitions.easing.sharp,
          duration: materialTheme.transitions.duration.leavingScreen
        })};
      `;
    }
  }}
`;

export default StyledSideNav;
